import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Client } from '../../models/client';
import { ClientsService } from '../clients.service';
import { CONTEXTS } from '../assets/constants';
import { UtilsService } from '../utils.service';

@Injectable({
  providedIn: 'root'
})
export class ContextService {
  private context: any = {};
  private contextPermissions: any = null;
  private contextPermissionsConfig: any;

  constructor(public clientsService: ClientsService) {}

  public setContextPermissionsConfig(contextPermissionsConfig) {
    this.contextPermissionsConfig = contextPermissionsConfig;
  }

  public async setContext(route: ActivatedRouteSnapshot, loggedUserClientId: string) {
    await this.loadClient(route, loggedUserClientId);
  }

  async loadClient(route: ActivatedRouteSnapshot, loggedUserClientId: string): Promise<Client | null> {
    // used by clientResolve not on setContext in the future this data should be in context
    const { group, student, agent, license } = route?.parent?.data || {};
    const clientId =
      route?.paramMap.get('clientId') ||
      route?.queryParamMap.get('clientId') ||
      group?.clientId ||
      student?.clientId ||
      agent?.clientIds?.[0] ||
      license?.clientId ||
      loggedUserClientId;

    let client: Client | null = null;

    if (clientId) {
      if (clientId === this.context.client?.id) {
        // skip context and permissions changes
        return this.context.client;
      } else {
        const query = { _id: clientId, populate: 'partner' };
        if (route?.paramMap.get('clientId')) query['getActiveData'] = true;
        const remoteClient = await this.clientsService.fetch(query);
        if (remoteClient?.docs?.length) {
          client = remoteClient.docs[0] as Client;
        }
      }
    }

    this.setClientPermissions(client);
    return client;
  }

  /**
   * Set the scorm client permissions for the scorm client
   * @param client
   */
  public setClientPermissions(client: Client | null): any {
    this.context.client = client;
    const clientPermissionsConfig = this.contextPermissionsConfig
      ? this.contextPermissionsConfig[CONTEXTS.clients.key]
      : {};

    let clientPermissions = {};

    CONTEXTS.clients.features.forEach((feature) => {
      if (feature.test(client)) {
        clientPermissions = UtilsService.deepMerge(clientPermissions, clientPermissionsConfig[feature.key]);
      }
    });
    this.contextPermissions = clientPermissions;
    return this.contextPermissions;
  }

  /**
   * Get the context permissions
   */
  public getContextPermissions(): any {
    return this.contextPermissions;
  }
}
